import React from 'react';
import {List} from 'antd-mobile';
import NearModal from './NearModal';

import './Near.less';

class NearLocation extends React.Component{
    constructor(props){
        super(props);
        this.state = {
            visible: false,
            extra: ''
        }
    }
    componentDidMount(){
        // 预加载地图依赖
        this.loadAMap(()=>{
            this.loadAMapUI();
        });
    }
    loadAMap = (callback) => {
        let protocol = window.location.protocol;
        let url = `${protocol}//webapi.amap.com/maps?v=1.4.8&key=${atob('NmRlMmUwYzcwMDUzNDM4OGVhYTYyMTI2YjQxMWU4ZWY=')}`;
        let $script = document.createElement('script');
        $script.type = "text/javascript";
        $script.onload= ()=>{
            callback && callback();
        }
        document.body.appendChild($script);
        $script.src = url;
    }
    loadAMapUI = () => {
        let protocol = window.location.protocol;
        let url = `${protocol}//webapi.amap.com/ui/1.0/main.js`;
        let script = window.document.createElement('script');
        script.type = "text/javascript";
        document.body.appendChild(script);
        script.src = url;
    }
    onShowNear = ()=>{
        this.setState({
            visible: true
        })
    }
    onSelect = (pois)=>{
        let location, value;
        if (pois){
            location = pois.location;
            value = `${pois.district ||""}${pois.pname||''}${pois.cityname||''}${pois.adname||''}${pois.address}${pois.name}`;
            let onChange = this.props.onChange;
            onChange && onChange([location.lng, location.lat, value].join('#%$'));
        }
        
        this.setState({
            visible: false,
            extra: value
        });
        
    }
    render(){
        let {visible} = this.state;
        let {errorText, value, isSignIn, is_sign_in} = this.props;
        let arr = value && value.split('#%$');
        let extra = arr && arr[2];
        
        return (
            <div>
                <div className="near-location">
                    {isSignIn 
                        ? (<div className='near-signin'>
                                {extra && <img alt='' src='data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAANCAYAAAHnMM+TAAAAAXNSR0IArs4c6QAAAW9JREFUKBVtUD0sQ1EUPue+12AoJUKCtsJq6MRai4VJxCTpwmJoQttEa9BB+hJeCAkLC7Ew6C4Ss0kkpAOGtro08Vva4fW9454rr9HEGc695/u+c853L8DfiBeMI5CpJIioD2N54wmAhhoSSa1ygfFiZowIViCWz9BX/ZsEw2ulHT5+AxPPGyHHrt80AIS6INteZyDaG1G4HKIj3+JFI0wOXaFUmYGUR4GxQiaLgKOANG36U9cYL2QsblG9MumaCOkMDLYMgOVY4NPb4b72eK78lK0X6PZ0SeAB5LycQMTjqlOD22pOTTCDySlhBpIR3soIChxXjJvcFyuSk3x5lAi3gEhzRepEtBFpWdrcZZun0tVsk0AW7HKyIwx75ROQK8/Y+oQrWuyZgw/7E4Zbg5B9vVAi5lija5o2Y9v2JQP7svu/YI36tvTbtq9Sqd0BQX+TEKHk9baNpDuX3pXQJRNFY95x6IBrIXBh0588dLkf/5GROfeb77sAAAAASUVORK5CYII=' />}
                                {extra && <div className='title'>{extra}</div>}
                                {is_sign_in && <a onClick={this.onShowNear}>{$st("重新定位")}</a>}
                            </div>)
                        : <List.Item arrow='horizontal' onClick={this.onShowNear}> {extra || $st('选择定位')}</List.Item>
                    }
                    {visible && <NearModal onSelect={this.onSelect} is_sign_in={is_sign_in} />}
                </div>
                {errorText&&<div className="input-error">{errorText}</div>}
            </div>
        )
    }
    
}
export default NearLocation;



// WEBPACK FOOTER //
// ./src/component/Location/Near.js